/**
 * UserMessage — one right-aligned amber bubble in the chat thread.
 *
 * Visual contract (locked 2026-06-15):
 *   - Right-aligned, max 80% of thread width
 *   - Amber gradient background matching the mockup
 *   - Pillow shape: 18px radius, 6px on the bottom-right corner to
 *     "point" to the user
 *   - 15px text, weight 500
 *   - Entrance: fade + 4px lift, 180ms cubic-bezier
 *
 * Day 7 (2026-06-15): useReducedMotion gates entrance.
 *
 * Stateless. Pure render from props.
 */

"use client";

import { motion, useReducedMotion } from "framer-motion";

import { MOTION, ms } from "@/lib/design-tokens";

export interface UserMessageProps {
  /** The exact text the user typed. */
  content: string;
}

export function UserMessage({ content }: UserMessageProps) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      initial={reduce ? { opacity: 0 } : { opacity: 0, y: 4 }}
      animate={reduce ? { opacity: 1 } : { opacity: 1, y: 0 }}
      transition={{
        duration: ms(reduce ? MOTION.fast : MOTION.base),
        ease: [0.16, 1, 0.3, 1],
      }}
      className="ml-auto max-w-[80%]"
    >
      <div
        className="text-[15px] font-medium"
        style={{
          background:
            "linear-gradient(135deg, rgba(253,230,138,0.95) 0%, rgba(251,191,36,0.95) 100%)",
          color: "#0a0908",
          padding: "12px 18px",
          borderRadius: "18px 18px 6px 18px",
          boxShadow: "0 4px 12px rgba(251,191,36,0.2)",
          wordBreak: "break-word",
        }}
      >
        {content}
      </div>
    </motion.div>
  );
}
